import { z } from 'zod';
/** Path parameters of a route that addresses one resource by its id. */
export const idParamsSchema = z.object({
    id: z.string().min(1),
});
/** Both platforms allow letters, digits, '-' and '_' only; anything else is rejected up front. */
export const usernameSchema = z
    .string()
    .trim()
    .regex(/^[A-Za-z0-9_-]{2,30}$/, 'must be 2–30 letters, digits, hyphens or underscores');
//# sourceMappingURL=common.js.map